import { createApp } from 'vue'
import App from './App.vue'
//import BootstrapVue from 'bootstrap-vue' // add
/*
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue' // add
import 'bootstrap/dist/css/bootstrap.css' // add
import 'bootstrap-vue/dist/bootstrap-vue.css' // add
//*/
//import router from '../../router'
//import store from '../../store'



createApp(App)
    .mount('#app')
